import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "onChange", "onBlur", "onFocus", "i18n", "id", "value", "children", "label", "defaultIsChecked", "isChecked", "isDisabled", "isInvalid", "hasState", "size", "mode"];
import { forwardRef } from 'react';
import { ThemeProvider } from 'styled-components';
import { StyledSwitch } from './Switch.styles';
import cx from 'classnames';
import { prefix } from '../../tools/settings';
import { useId } from '../../hooks';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Switch = forwardRef(function (_ref, ref) {
  var _cx;

  var customClassName = _ref.className,
      onChange = _ref.onChange,
      onBlur = _ref.onBlur,
      onFocus = _ref.onFocus,
      _ref$i18n = _ref.i18n,
      i18n = _ref$i18n === void 0 ? {
    on: 'On',
    off: 'Off'
  } : _ref$i18n,
      id = _ref.id,
      value = _ref.value,
      children = _ref.children,
      label = _ref.label,
      defaultIsChecked = _ref.defaultIsChecked,
      isChecked = _ref.isChecked,
      isDisabled = _ref.isDisabled,
      isInvalid = _ref.isInvalid,
      hasState = _ref.hasState,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      _ref$mode = _ref.mode,
      mode = _ref$mode === void 0 ? 'light' : _ref$mode,
      rest = _objectWithoutProperties(_ref, _excluded);

  var className = cx((_cx = {}, _defineProperty(_cx, "".concat(prefix, "-switch"), true), _defineProperty(_cx, customClassName, !!customClassName), _cx));
  var fallbackId = useId('switch');

  var _id = id || fallbackId;

  return _jsx(ThemeProvider, {
    theme: {
      mode: mode,
      size: size
    },
    children: _jsxs(StyledSwitch, {
      className: className,
      children: [_jsx("input", {
        type: "checkbox",
        ref: ref,
        id: _id,
        value: value,
        onChange: onChange,
        onBlur: onBlur,
        onFocus: onFocus,
        defaultChecked: defaultIsChecked,
        "aria-checked": isChecked,
        "aria-invalid": isInvalid,
        checked: isChecked,
        "aria-disabled": isDisabled,
        disabled: isDisabled,
        className: "".concat(prefix, "-switch__input")
      }), _jsxs("label", {
        className: "".concat(prefix, "-switch__label"),
        htmlFor: _id,
        children: [_jsx("span", {
          className: "".concat(prefix, "-switch__toggle")
        }), children && _jsx("span", {
          className: "".concat(prefix, "-switch__text"),
          children: children
        })]
      })]
    })
  });
});
export default Switch;